import calendarImg from '@/assets/images/calendarImg.png'
import { deviceDetector } from '@/helpers/deviceDetector'

import s from './styles.module.scss'

const isMobile = deviceDetector()

export const STEPS = [
  {
    target: 'body',
    disableBeacon: true,
    placement: 'center',
    content: (
      <div className={s.introTourWrapper}>
        <h2>Te mostraremos todo el poder de Calu</h2>
        <p>Con un recorrido por todo el sistema de agendas</p>
        <img src={calendarImg} alt="Calendario" />
        <button
          onClick={() => {
            document.querySelector('[data-action="primary"]')?.click()
          }}
          className={s.botonCta}
        >
          Iniciar el recorrido
        </button>
      </div>
    ),
    styles: {
      options: {
        zIndex: 9999,
        backgroundColor: '#fff',
        width: 600,
        textAlign: 'center',
        overlayColor: 'rgba(0, 0, 0, 0.3)',
      },
      tooltip: {
        padding: 32,
      },
      buttonNext: {
        display: 'none', // Ocultamos el botón original
      },
      buttonBack: {
        display: 'none',
      },
      buttonSkip: {
        display: 'none',
      },
    },
  },
  // Paso 1: solo se muestra si es mobile
  ...(isMobile
    ? [
        {
          content: 'Aca podes acceder al calendario para elegir qué día querés ver en la agenda',
          target: '.calendarTriggerBtn',
          placement: 'right',
          styles: {
            options: {
              width: 400,
              zIndex: 1000,
            },
          },
        },
      ]
    : []),
  {
    target: '.calendarMiniTour',
    content: 'El día que elijas en el calendario será el que visualices en la agenda',
    placement: 'bottom',
    styles: {
      options: {
        minWidth: 'auto',
        zIndex: 1000,
      },
    },
  },
  {
    content: 'Para asignar un turno, hacé clic sobre el horario deseado',
    placement: 'right',
    target: '.tourStep2',
    title: 'Asignar cita',
    styles: {
      options: {
        width: 300,
        zIndex: 1000,
      },
    },
  },
  {
    target: '.firstEvent',
    content:
      'Creamos este turno de prueba para que puedas explorar cómo funciona la agenda. Probá abrirlo, editarlo o eliminarlo: es solo un ejemplo.',
    placement: 'top',
    title: '👉 Turno de ejemplo',
    styles: {
      options: {
        width: 300,
        zIndex: 1000,
      },
    },
  },
]
